import pedidoVentaService, {
  PedidoVenta,
  PedidoVentaDetalle,
} from './pedidoVentaService';
import { repartirLineaConversion } from '../utils/pedidoConversionCantidades';

export type AplicarConversionMaestrosResult = {
  pedido: PedidoVenta;
  /** True si alguna línea quedó con Cantidad B > 0 tras el floor. */
  tieneCantidadB: boolean;
};

/**
 * POST conversion-automatica?modo=maestros y corrige cantidades con floor
 * (p. ej. 2 uds @ 30% → B = 0), persistiendo el pedido corregido.
 * No copia a otros tenants (eso es copiar-relacionados / Enviar pedido).
 */
export async function aplicarConversionMaestrosConFloor(
  pedidoId: number,
): Promise<AplicarConversionMaestrosResult> {
  let actualizado = await pedidoVentaService.conversionDesdeMaestros(pedidoId);
  if (!actualizado) {
    actualizado = await pedidoVentaService.getPedidoVenta(pedidoId, { sinCache: true });
  }

  const detalles: PedidoVentaDetalle[] = (actualizado.detalles ?? []).map((d, idx) => {
    const state = repartirLineaConversion(
      d.cantidad,
      d.cantidadB,
      d.porcCantB ?? d.porcSubtotalCantB,
    );
    return {
      ...d,
      nroItem: d.nroItem || idx + 1,
      cantidad: state.cantidad,
      cantidadB: state.cantidadB,
      porcCantB: state.porcentaje,
      porcSubtotalCantB: state.porcentaje,
      subtotal: Number(d.precioUnitario ?? 0) * state.cantidad,
      precioMinimo: undefined,
    };
  });

  const importeTotal = detalles.reduce((acc, d) => {
    const sub = d.subtotal ?? Number(d.precioUnitario ?? 0) * Number(d.cantidad ?? 0);
    return acc + sub;
  }, 0);

  const corregido: PedidoVenta = {
    ...actualizado,
    detalles,
    importeTotal,
  };

  await pedidoVentaService.updatePedidoVenta(pedidoId, corregido, { preservarPrecios: true });

  return {
    pedido: corregido,
    tieneCantidadB: detalles.some((d) => Number(d.cantidadB ?? 0) > 0),
  };
}

export function pedidoTieneCantidadB(pedido: PedidoVenta | null | undefined): boolean {
  return (pedido?.detalles ?? []).some((d) => Number(d.cantidadB ?? 0) > 0);
}

export function puedeConversionPedidoListado(p: PedidoVenta): boolean {
  const estado = p.estado || 'Nuevo';
  const facturado = String(p.facturado ?? '').trim().toUpperCase();
  const nroFactura = Number(p.nroFormularioFactura ?? 0);
  return (estado === 'Nuevo' || estado === 'Impreso') && facturado !== 'S' && nroFactura === 0;
}
